import StationList from "../../../features/stations/components/StationList";
import HeaderTitleContent from "../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import SectionTitle from "../../../common/components/atom/SectionTitle/SectionTitle";
import NewStation from "../../../features/stations/components/NewStation";
import PageContent from "../../../common/components/atom/PageContent/PageContent";

export default function StationListPage() {
  return (
    <PageContent>
      <HeaderTitleContent>Stations</HeaderTitleContent>
      <NewStation.AddFormModal />
      <div style={{ height: 50 }} />
      <div>
        <SectionTitle iconType={"electricStation"}>Station List</SectionTitle>
      </div>
      <StationList.Filter />
      <StationList.List />
    </PageContent>
  );
}
